export const OPEN_MODAL_COMPLETE_TASK = 'OPEN_MODAL_COMPLETE_TASK';
export const CLOSE_MODAL_ADD_QA = 'CLOSE_MODAL_ADD_QA';
export const OPEN_MODAL_ADD_QA = 'OPEN_MODAL_ADD_QA';
